module.exports = __webpack_public_path__ + "img/duca.2299fa9f.png";